import React, { Component } from 'react';
import enhance from './enhance';
import './link-icon.css';

class LinkIcon extends Component {
  render() {
    const { lineHeight, name, goToPage } = this.props;
    return (
      <div className="link-icon" onClick={goToPage}>
        <i className={`ui icon ${name}`} style={{ lineHeight }} />
      </div>
    );
  }
}

export default enhance(LinkIcon);



// WEBPACK FOOTER //
// ./src/components/link-icon/index.js